<section class="position-relative">
    <div class="bg-top-category bg-top-mob-category red-line mb-md-3 category-margin"
        [ngClass]="{'no-gradient': backgroundImage}"
        [ngStyle]="backgroundImage ? {'background-image': backgroundImage} : null"> 
    </div>
    <div class="container-fluid ps-lg-4 ps-xl-5 category-margin">
        <div class="row w-100">
            <div class="col-12 col-md-8 col-lg-7 col-xl-6 col-xxl-5 py-3 pt-md-4 title-wrap text-start ">
                <h1 class="category-heading">{{vehicle_name}} <span class="d-block">{{ categoryData?.category_name | removeBackslash}}</span></h1>
                <h2 class="category-description" [innerHTML]="categoryData?.full_description"
                    [ngClass]="{'text-truncate-3': !isMobileDescriptionExpanded}"></h2>
                <a class="read-more d-block d-md-none mt-2" role="button"
                    *ngIf="categoryData?.full_description?.length > 120" (click)="toggleDescription()">
                    {{ isMobileDescriptionExpanded ? 'Read Less' : 'Read More' }}
                </a>
            </div>
        </div>
    </div>
<!-- <div class="my-0 my-md-5">
    <br>
</div> -->
    <div class="position-absolute top-0 start-50 translate-middle z-3 d-none d-md-flex justify-content-center w-100"
        *ngIf="isSearchByVehicleDisabled">
        <app-shop-by-vehicle></app-shop-by-vehicle>
    </div>
</section>